import { loader_quotes } from '@/utils/datasets/loader_quotes';
import { loader_quotes_en } from '@/utils/datasets/loader_quotes_en';
import { quotes } from '@/utils/datasets/quotes';
import { DateTime } from 'luxon';
import { createAnswers, performLogout } from './client/client_api';
import { getFirebaseClientAuth } from '@/lib/firebase-client-config';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { ROUTE_LANDING } from '@/navigation';


export function beautifyDateTime(dateTime: DateTime | string | null | undefined): string {
  if (!dateTime) {
    return '';
  }

  const parsedDateTime = DateTime.fromISO(dateTime.toString());
  if (!parsedDateTime.isValid) {
    return '';
  }

  return parsedDateTime.toFormat('dd/MM/yyyy HH:mm:ss');
};

export const capitalizeAllWords = (str: string): string => {

  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export function beautifyDateTimeToDate(dateTime: DateTime | string | null | undefined): string {
  if (!dateTime) {
    return 'Info Mancante';
  }

  const parsedDateTime = DateTime.fromISO(dateTime.toString()).setLocale('it');
  if (!parsedDateTime.isValid) {
    return '';
  }

  const cleanDateTime = capitalizeAllWords(parsedDateTime.toFormat('dd MMMM yyyy'))

  return cleanDateTime;
};


export function beautifyDate(date: Date | string | null | undefined): string {
  if (!date) {
    return '';
  }

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    return '';
  }

  const day = parsedDate.getDate().toString().padStart(2, '0');
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
  const year = parsedDate.getFullYear().toString();

  return `${day}/${month}/${year}`;
};


export function convertToPlainObject(complexObject: any) {
  if (complexObject === undefined) return complexObject;
  return JSON.parse(JSON.stringify(complexObject));
}

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const extractVowels = (str: string): string => {
  return str.replace(/[^AEIOU]/gi, '')
}

const extractConsonants = (str: string): string => {
  return str.replace(/[^BCDFGHJKLMNPQRSTVWXYZ]/gi, '')
}

const surnameCode = (surname: string): string => {
  const codeSurname = `${extractConsonants(surname)}${extractVowels(surname)}XXX`;
  return codeSurname.substring(0, 3).toUpperCase()
}

const nameCode = (name: string): string => {
  let codNome = extractConsonants(name)
  if (codNome.length >= 4) {
    codNome = codNome.charAt(0) + codNome.charAt(2) + codNome.charAt(3)
  } else {
    codNome += `${extractVowels(name)}XXX`
    codNome = codNome.substring(0, 3)
  }
  return codNome.toUpperCase()
}

export const validateTaxCode = (taxCode: string, firstName: string, lastName: string): boolean => {
  if (taxCode.length !== 16) {
    return false;
  }
  const expectedLastNameCode = surnameCode(lastName);
  const expectedFirstNameCode = nameCode(firstName);
  // console.log('expectedLastNameCode', expectedLastNameCode);
  // console.log('expectedFirstNameCode', expectedFirstNameCode);

  const actualLastNameCode = taxCode.substring(0, 3).toUpperCase();
  const actualFirstNameCode = taxCode.substring(3, 6).toUpperCase();

  // console.log('actualLastNameCode', actualLastNameCode);
  // console.log('actualFirstNameCode', actualFirstNameCode);

  console.log(actualLastNameCode === expectedLastNameCode && actualFirstNameCode === expectedFirstNameCode);


  return actualLastNameCode === expectedLastNameCode && actualFirstNameCode === expectedFirstNameCode;
};

export const validatePassword = (password: string) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  const result = regex.test(password);
  return result;
}



export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

export const beautifyUnit = (unit: string): string => {
  const unitMap: Record<string, string> = {
    'h': 'ore',
    'd': 'giorni',
    'w': 'settimane',
    'm': 'mesi',
    'y': 'anni',
  };
  return unitMap[unit] || unit;
}

export const isMobile = (userAgentString: string | null | undefined) => {
  if (userAgentString) {
    return /mobile/i.test(userAgentString);
  }
  return false
}

// calcola la parte netta della ral
export const calculateRalNet = (ral: number): number => {
  if (ral <= 28000) {
    return ral * 0.77
  } else if (ral <= 50000) {
    return 21560 + (ral - 28000) * 0.65
  } else {
    return 21560 + 14300 + (ral - 50000) * 0.57
  }
}

// calcola la parte di costo della ral
export const calculateRalLord = (ral: number): number => {
  if (ral <= 28000) {
    return ral * 0.33
  } else if (ral <= 50000) {
    return 6440 + (ral - 28000) * 0.35
  } else {
    return 6440 + 7700 + (ral - 50000) * 0.43
  }
}


export const getQuote = (locale: string): any => {
  const randomIndex = Math.floor(Math.random() * quotes[locale].length);
  return quotes[locale][randomIndex];
}

export const getLoaderQuote = (lang: string): any => {
  const randomIndex = Math.floor(Math.random() * (lang === 'it' ? loader_quotes.length : loader_quotes_en.length));
  return (lang === 'it' ? loader_quotes[randomIndex] : loader_quotes_en[randomIndex]);
}


export const beautifyMoney = (money: number | null | undefined, maximumFractionDigits = 0) => {
  if (money == null || money == undefined) {
    return new Intl.NumberFormat('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: maximumFractionDigits }).format(0) + '€';
  }
  return new Intl.NumberFormat('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: maximumFractionDigits }).format(money) + '€';
}

const toTitleCase = (str: string) => {
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}


export const editSchoolOption = (input: string, capitalizeFirstLetter: boolean = false) => {
  let modifiedString = input.toLowerCase();

  // if (capitalizeFirstLetter && modifiedString.length > 1) {
  //   modifiedString = modifiedString.charAt(0).toUpperCase() + modifiedString.slice(1);
  // }

  return toTitleCase(modifiedString);
}


export const beautifyCourses = (degreeType: string, texts: any) => {

  switch (degreeType) {
    case 'LT':
      return texts.degreeTypeLT;
    case 'LMCU':
      return texts.degreeTypeLMCU;
    case 'LM':
      return texts.degreeTypeLM;
    case 'Corso Its':
      return texts.degreeTypeITS;
    case 'Master_I':
      return texts.degreeTypeMaster_I;
    case 'Master_II':
      return texts.degreeTypeMaster_II;
    case 'PhD':
      return texts.degreeTypePhD;
    case 'AFAM':
      return texts.degreeTypeAFAM;
    default:
      return '';
  }
}


export const sendAnswerFromButton = async (completedQuestion: string, completedAnswer: string) => {
  const answers = [{
    question: completedQuestion,
    answer: completedAnswer,
  }];
  if (completedAnswer) {
    answers.push({
      question: completedQuestion,
      answer: completedAnswer
    })
  }

  await createAnswers({
    answers: answers,
  });
}

export const formatName = (name) => {
  return name
    .trim()
    .split(' ')
    .join(' ');
};

export const checkAuthStateGeneral = async () => {
  const firebaseAuth = await getFirebaseClientAuth();

  onAuthStateChanged(firebaseAuth!, (user) => {
    if (user) {
      console.log('user info', {
        uid: user.uid,
        email: user.email,
        displayName: user.email,
      });
      console.log('user.isAnonymous', user.isAnonymous);

    } else {

      console.log('no user from firebse');
    }
  });
};

// export const checkAccount = async (email:string) => {

//     const responseGetAccount = await performGetAccount(email);

//     if (responseGetAccount.isOk) {
//         console.log('responseGetAccount OK');
//         console.log(responseGetAccount);


//     } else {
//         console.log('responseGetAccount KO');
//     }


// };
export const handleLogout = async (reset: () => void, animatedRoute: (route: string) => void) => {

  try {
    const firebaseClientAuth = await getFirebaseClientAuth();
    if (!firebaseClientAuth) {
      throw new Error('firebaseClientAuth is null');
    }

    await performLogout();

    await signOut(firebaseClientAuth);

    reset();
    animatedRoute(ROUTE_LANDING);
  } catch (error) {
    console.error("Error logging out:", error);
  }
};



export const addClassToAnchorTags = (htmlContent: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const links = doc.querySelectorAll('a');
  links.forEach((link) => {
    link.classList.add('text-primaryBlue700', 'font-bold', 'ml-1');
  });
  return doc.body.innerHTML;
};
